/**
 * ユーザーロール定数
 *
 * データベースのuser_rolesテーブルのIDに対応
 */
export const ROLE_IDS = {
  /** 開発ユーザー - 全ての機能にアクセス可能 */
  DEV_USER: 1,
  /** MCMユーザー - MCM管理機能にアクセス可能 */
  MCM_USER: 2,
  /** 現場ユーザー - 割り当てられた現場で閲覧・編集可能 */
  SITE_USER: 3,
  /** 現場閲覧者 - 割り当てられた現場で閲覧のみ可能 */
  SITE_VIEWER: 4,
} as const;

export type RoleId = (typeof ROLE_IDS)[keyof typeof ROLE_IDS];

/**
 * ロール名定数
 */
export const ROLE_NAMES: Record<RoleId, string> = {
  [ROLE_IDS.DEV_USER]: '開発ユーザー',
  [ROLE_IDS.MCM_USER]: 'MCMユーザー',
  [ROLE_IDS.SITE_USER]: '現場ユーザー',
  [ROLE_IDS.SITE_VIEWER]: '現場閲覧者',
} as const;

/**
 * サイト制限が適用されるロール
 * これらのロールは割り当てられたサイトのみアクセス可能
 */
export const SITE_RESTRICTED_ROLES: readonly RoleId[] = [
  ROLE_IDS.SITE_USER,
  ROLE_IDS.SITE_VIEWER,
] as const;

/**
 * 閲覧専用ロール
 * これらのロールは編集操作が禁止される
 */
export const VIEW_ONLY_ROLES: readonly RoleId[] = [
  ROLE_IDS.SITE_VIEWER,
] as const;

/**
 * 管理者ロール（全サイトアクセス可能）
 */
export const ADMIN_ROLES: readonly RoleId[] = [
  ROLE_IDS.DEV_USER,
  ROLE_IDS.MCM_USER,
] as const;
